var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"device-case-detail"},[_c('DetailTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }